import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessServiceProperty } from './process-service-property';
export { ProcessServiceProperty };
import { processServicePropertySchema } from '@schemas/business-objects/process-service-property';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';
import { ProcessServiceFormGroup } from './process-service-form-group';

export class ProcessServicePropertyFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    isArray: SchemaFormControl;
    isInput: SchemaFormControl;
    isOutput: SchemaFormControl;
    required: SchemaFormControl;
    description: SchemaFormControl;
    sequence: SchemaFormControl;
    serviceId: SchemaFormControl;
    service: ProcessServiceFormGroup;
    typeId: SchemaFormControl;
    type: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessServiceProperty>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processServicePropertySchema, ProcessServiceProperty, data, options);
  }

  get object(): ProcessServiceProperty {
    return new ProcessServiceProperty(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'service':
        return new ProcessServiceFormGroup();
      case 'type':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessServiceProperty[]> {
    return ProcessServiceProperty.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessServiceProperty | null> {
    return ProcessServiceProperty.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessServiceProperty> {
    return ProcessServiceProperty.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessServiceProperty>,
  ): Promise<ProcessServiceProperty> {
    return ProcessServiceProperty.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessServiceProperty>,
  ): Promise<ProcessServiceProperty> {
    return ProcessServiceProperty.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessServiceProperty.deleteById(id);
  }
}

export class ProcessServicePropertyFormArray extends PersistedFormArray {
  declare controls: ProcessServicePropertyFormGroup[];

  readonly entityName = 'ProcessServiceProperty' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processServicePropertySchema, ProcessServiceProperty, options);
  }

  protected override createItemGroup() {
    return new ProcessServicePropertyFormGroup();
  }

  get array(): ProcessServiceProperty[] {
    return this.controls.map(
      (group: ProcessServicePropertyFormGroup) => group.object,
    );
  }
}

export class ProcessServicePropertyPersistedArray extends PersistedArray<ProcessServiceProperty> {
  readonly entityName = 'ProcessServiceProperty' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessServiceProperty, options);
  }
}
